<script setup lang="ts">
import axios from 'axios'

import useOverflow from '@/composables/useOverflow'
const props = defineProps<{
  dashboard: number
}>()
const { toggle } = useOverflow()

const url = ref('')
const loading = ref(true)
const fetchDashboard = async () => {
  loading.value = true
  return await axios.get(`/metabase/dashboard-link?dashboard=${props.dashboard}`).then((response) => {
    return response.data.link
  })
}

const headerHeight = ref(0)
const headerRef = ref<HTMLElement | null>(null)

onMounted(async () => {
  toggle(true)

  headerHeight.value = headerRef.value?.offsetHeight ?? window.innerHeight

  url.value = await fetchDashboard()
  loading.value = false
})

onBeforeUnmount(() => {
  toggle(false)
})
</script>

<template>
  <div ref="headerRef">
    <slot name="header" />
  </div>

  <TheLoadingPage v-if="loading" />
  <div v-else class="px-6 pb-6 sm:pb-12">
    <iframe
      :src="url"
      frameBorder="0"
      :style="`width: 100%; height: calc(100vh - ${headerHeight}px)`"
      allowTransparency
    />
  </div>
</template>
